import React from 'react';
import {injectIntl, intlShape} from 'react-intl';
import sendImg from './img/send_button.svg';

class NewConversationBody extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      body:""
    }
    this.handleBodyChange = this.handleBodyChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleSendBtnClick = this.handleSendBtnClick.bind(this);
  }

  handleBodyChange(e){
    this.setState({body: e.target.value});
  }

  handleKeyPress(e){
      if(e.which == 13){
      this.handleSendBtnClick();
    }
  }

  handleSendBtnClick(){
    this.props.onSubmit(this.state.body);
  }

  render(){
    return(
      <div className="new-conversation">
        <div className="sender">
          <input value={this.state.body} 
            onChange={this.handleBodyChange}
            onKeyPress={this.handleKeyPress}
            type="text" className="new-message" placeholder={"Message"}
            autoFocus autoComplete="off" />
          <button className="send" onClick={this.handleSendBtnClick}
            disabled={!this.state.body}>
            <img src={sendImg} className="send-icon" alt="send" />
          </button>
        </div>
      </div>
    );
  }

}

export default injectIntl(NewConversationBody);